import { render } from "./TeamDashboard.vue?vue&type=template&id=02248c60&scoped=true"
import script from "./TeamDashboard.vue?vue&type=script&lang=js"
export * from "./TeamDashboard.vue?vue&type=script&lang=js"

import "./TeamDashboard.vue?vue&type=style&index=0&id=02248c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02248c60"]])

export default __exports__